import { useState, useEffect } from "react"

const useVisitedLinks = () => {
  const [visitedLinks, setVisitedLinks] = useState([])

  useEffect(() => {
    const storedVisitedLinks = localStorage.getItem("visitedLinks")
    if (storedVisitedLinks) {
      setVisitedLinks(JSON.parse(storedVisitedLinks))
    }
  }, [])

  const handleVisit = linkId => {
    if (linkId && !isVisited(linkId)) {
      const updatedVisitedLinks = [...visitedLinks, linkId]
      setVisitedLinks(updatedVisitedLinks)
      localStorage.setItem("visitedLinks", JSON.stringify(updatedVisitedLinks))
    }
  }

  const isVisited = linkId => {
    return visitedLinks.includes(linkId)
  }

  return { visitedLinks, handleVisit, isVisited }
}

export default useVisitedLinks
